import { JobRolePageContent } from '../../@import-types/contentful/JobRolePage.types'
import useGlobalStartPage from '../globalContent/useGlobalStartPage'

import usePageLink from './usePageLink'

export default function useJobPageLink(job: JobRolePageContent) {
  const globalStartPage = useGlobalStartPage()
  return usePageLink(globalStartPage?.joinUsPage?.slug, job.slug)
}
